'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ./~/shortid/lib/util/cluster-worker-id-browser.js
// module id = 473
// module chunks = 4 6 7 8 9 10 12 19 21 22 24 27 55 56